// React
import React from "react";
// Bootstrap
import { Well } from "react-bootstrap";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SimpleErrorBlock.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export class SimpleErrorBlock extends React.Component {
    render() {
        let { title, subTitle } = this.props;
        return (React.createElement("div", { className: styles.container },
            React.createElement(Well, { className: styles.errorMessages },
                React.createElement("h3", null, title),
                subTitle && React.createElement("h4", null, subTitle))));
    }
}
